import templateUrl from "emun.order/retrieve-token-info.htm";
import RetrieveTokenInfoController from "emun.order/retrieve-token-info.controller";
import open from "webmodals/open";

let RetrieveTokenInfo = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
	  controller: RetrieveTokenInfoController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default RetrieveTokenInfo;
